import theme from 'config/theme';

export default {
  saveButtonWrapper: {
    marginBottom: '16px',
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  section: {
    marginBottom: '16px',
  },
  subsection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  },
  title: {
    marginBottom: '6px',
    fontSize: '18px',
    fontWeight: 500,
    color: theme.palette.darkGray.main,
  },
  subtitle: {
    marginBottom: '16px',
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.darkGray.main,
  },
  row: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flexDirection: 'column',

    '@media (min-width: 768px)': {
      flexDirection: 'row',
    },
  },
  borderRow: {
    width: '50%',
    marginLeft: 'auto',
    marginBottom: 0,
    '&>div': {
      marginBottom: 0,
    },
    '&>div label': {
      borderBottom: 'none!important',
    },
    '@media (max-width: 1020px)': {
      width: '100%',
      marginLeft: '0',
    },
  },
  bottomFieldsInner: {
    marginBottom: '16px',
    borderBottom: '1px solid #E9E9E8',
  },
  bottomFields: {
    width: '50%',
    marginLeft: 'auto',
    '@media (max-width: 1020px)': {
      width: '100%',
      marginLeft: '0',
    },
  },
  fieldWrapper: () => ({
    marginBottom: '20px',
  }),
};
